/**
 * Edited post text survives closing the dialog for the life of this tab.
 * Kept separately from OAuth state: writing does not require connecting an account.
 * Neither text nor credentials are written to browser storage.
 */
const editedTexts = new Map<string, string>();

const key = (publicCode: string, lang: string): string => `${publicCode}:${lang}`;

export function rememberedShareText(publicCode: string, lang: string): string | undefined {
  return editedTexts.get(key(publicCode, lang));
}

export function rememberShareText(publicCode: string, lang: string, text: string): void {
  editedTexts.set(key(publicCode, lang), text);
}

/** Test isolation; normal navigation never clears another record's draft. */
export function forgetAllShareTexts(): void {
  editedTexts.clear();
}
